import React from 'react';
import RecordCarousel from './RecordCarousel';
import { sanitizeRichTextHtml } from '../lib/richText';

const RecordCard = ({ holder }) => {
  const images = (holder.images || []).filter(Boolean);

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300">
      {images.length > 0 && <RecordCarousel images={images} />}

      <div className="p-6">
        {holder.certificate_image && (
          <div className="float-right mb-3 ml-5 w-40 overflow-hidden rounded-lg border-2 border-yellow-600 bg-white shadow-md sm:w-48">
            <img
              src={holder.certificate_image}
              alt={`${holder.name} certificate`}
              className="aspect-[3/4] w-full object-contain"
            />
          </div>
        )}

        <h3 className="text-xl font-bold text-gray-900">{holder.name}</h3>
        <p className="mt-2 whitespace-pre-line text-sm text-gray-600">{holder.title}</p>
        {holder.achievement && (
          <div
            className="rich-text-content mt-3 text-justify text-sm leading-6 text-gray-700 [overflow-wrap:anywhere]"
            dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(holder.achievement) }}
          />
        )}
        <div className="clear-both" />
      </div>
    </div>
  );
};

export default RecordCard;
